import { DateRange, VFlow } from 'bold-ui'
import { Breadcrumb } from 'components/breadcrumb'
import { PageContent } from 'components/layout/PageContent'
import { PageHeaderSection } from 'components/PageHeaderSection'
import { PivotTable, PivotTableInitialValues } from 'components/pivot-table/PivotTable'
import { useTreeBuilder } from 'components/pivot-table/tree-builder/useTreeBuilder'
import { AsyncProcessingNameEnum, TipoModuloEnum } from 'graphql/types.generated'
import { useCallback, useState } from 'react'
import { isUndefinedOrNull } from 'util/checks'

import {
  ASYNC_LOADING_MESSAGE,
  RELATORIO_GERENCIAL_EXAMES_FILTER_STORAGE_KEY,
} from '../common/model-relatorioGerencial'
import { useAsyncRelatorioGerencial } from '../common/useAsyncRelatorioGerencial'
import { RelatorioGerencialFiltrosFormModel } from '../components/form/model-relatorioGerencialFiltrosForm'
import { RelatorioGerencialTableWrapper } from '../components/RelatorioGerencialTableWrapper'
import { examesKeyMapping } from './keyMapping-relatorioGerencialExames'
import { RelatorioGerencialExamesModel } from './model-relatorioGerencialExames'
import { RelatorioGerencialExamesInfoAlert } from './RelatorioGerencialExamesDetalhesAlert'

const TITLE = 'Relatório gerencial de exames'

const OPERATIONS = {
  build: '/api/gerenciais/exames/build',
  meta: '/api/gerenciais/exames/meta',
}

export const RelatorioGerencialExamesView = () => {
  const [dateRangeFilter, setDateRangeFilter] = useState<DateRange>()

  const [pivotTableInitialValues, setPivotTableInitialValues] = useState<
    PivotTableInitialValues<RelatorioGerencialExamesModel>
  >()

  const {
    metaState,
    meta,
    setDateFilter,
    treeBuilderStatus: { isBuilding, isSearchingMeta },
    isMetaEmpty,
    setIsSearchingMeta,
    ...rest
  } = useTreeBuilder<RelatorioGerencialExamesModel>({
    keyMapping: examesKeyMapping,
    operations: OPERATIONS,
  })

  const onGetMeta = useCallback(
    ({ periodo, unidade }: RelatorioGerencialFiltrosFormModel) => {
      setDateFilter(periodo, unidade)
      setDateRangeFilter(periodo)
    },
    [setDateFilter]
  )

  const { handleSubmit, filtros, isAsyncProcessingRunning } = useAsyncRelatorioGerencial({
    asyncProcessingName: AsyncProcessingNameEnum.RELATORIO_GERENCIAL_EXAMES,
    filterStorageKey: RELATORIO_GERENCIAL_EXAMES_FILTER_STORAGE_KEY,
    isSearchingMeta,
    hasMetaState: !isUndefinedOrNull(metaState),
    meta,
    onGetMeta,
    setIsSearchingMeta,
  })

  return (
    <>
      <Breadcrumb title={TITLE} />
      <PageHeaderSection title={TITLE} />
      <PageContent type='filled'>
        <VFlow>
          <RelatorioGerencialExamesInfoAlert />
          <RelatorioGerencialTableWrapper<RelatorioGerencialExamesModel>
            loading={isSearchingMeta || isAsyncProcessingRunning}
            loadingMessage={ASYNC_LOADING_MESSAGE}
            isEmpty={isMetaEmpty}
            onSubmit={handleSubmit}
            keyMapping={examesKeyMapping}
            filtrosLocalStorage={filtros}
            modulo={TipoModuloEnum.RELATORIO_GERENCIAL_EXAMES}
            setPivotTableInitialValues={setPivotTableInitialValues}
            hasFiltroPeriodo
          >
            {metaState && dateRangeFilter && (
              <PivotTable<RelatorioGerencialExamesModel>
                title={TITLE}
                treeMeta={metaState}
                keyMapping={examesKeyMapping}
                dateRangeFilter={dateRangeFilter}
                isBuilding={isBuilding}
                initialValues={pivotTableInitialValues}
                {...rest}
              />
            )}
          </RelatorioGerencialTableWrapper>
        </VFlow>
      </PageContent>
    </>
  )
}
